<script lang="ts">
	import CloseIcon from 'assets/svg/closeIcon.svg?component';
	import { afterUpdate, onMount } from 'svelte';
	import Portal from 'components/Portal/Portal.svelte';

	export let active: boolean;
	export let toggleModal: () => void;
	export let dark: boolean = false;

	function close(e: KeyboardEvent) {
		if (e.key === 'Escape') {
			active = false;
		}
	}
	onMount(() => {
		window.addEventListener('keydown', close);
		return () => {
			window.removeEventListener('keydown', close);
		};
	});

	//prevent scrolling behind modal
	afterUpdate(() => {
		if (active) {
			document.body.style.overflow = 'hidden';
		}
		if (!active) {
			document.body.style.overflow = 'unset';
		}
	});
</script>

<Portal>
	<div class="backdrop" class:dark class:active on:click|self={() => toggleModal()}>
		<div class="modal-content" class:active>
			<div
				class="icon-wrapper"
				on:click={() => {
					toggleModal();
				}}
			>
				<CloseIcon class="modal-close-icon" width="18" height="18" alt="" />
			</div>
			<slot />
		</div>
	</div>
</Portal>

<style lang="scss">
	@import 'modal';
</style>